export const morningBriefingTitle = "yo30Qd";
export const morningBriefingSUADisplayText = "CWWyxb";
export const morningBriefingDescription = "essB9b";
export const eveningBriefingTitle = "_UsLvb";
export const eveningBriefingSUADisplayText = "kXf55b";
export const eveningBriefingDescription = "ARQCje";
export const inboxBriefingMorningCommandText = "A8wpvb";
export const inboxBriefingEveningCommandText = "sYBY$b";
export default {morningBriefingTitle,morningBriefingSUADisplayText,morningBriefingDescription,eveningBriefingTitle,eveningBriefingSUADisplayText,eveningBriefingDescription,inboxBriefingMorningCommandText,inboxBriefingEveningCommandText};